import {
  setMe,
  setUnreadInboxCount,
  setHasSpecification,
} from "@/core/redux/slices/user";
import { useDispatch } from "@/core/redux/store";
import authService from "@/shared/services/api/auth-service";
import { useEffect } from "react";

export default function DashboardLayoutViewModel() {
  const dispatch = useDispatch();

  const getUserData = async () => {
    const userResponse = await authService.getMe();
    if (userResponse.success) {
      const userDetail = userResponse.data.user;
      const hasSpecification = userResponse.data.hasSpecification;
      const unreadInboxCount = userResponse.data.unreadInboxCount;
      dispatch(setMe(userDetail));
      dispatch(setUnreadInboxCount(unreadInboxCount));
      dispatch(setHasSpecification(hasSpecification));
    }
  };

  useEffect(() => {
    getUserData();
  }, []);

  return {};
}
